import { Grid } from "@sidelinesports/fan-design-system";
import type { ReactElement, ReactNode } from "react";

export const IllustratedMessage = ({
  children,
  illustration,
}: {
  children: ReactElement | ReactElement[];
  illustration: ReactNode;
}) => (
  <Grid gap={16} alignItems="center">
    {illustration}
    {children}
  </Grid>
);
